module.exports = __webpack_public_path__ + "img/vip-24-hours.6a6e3e47.png";